import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loanService } from '../../services/loanService';

export const useGetRefinBannerStatus = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.loan.refin_banner_status],
    queryFn: () =>
      loanService.refinBannerStatus().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
      }),
  });
};
